import React, { useState, useRef, useEffect, ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DropdownMenuProps } from "./DropdownType";
import { Button } from "components/Button/Button";
import { createPortal } from "react-dom";



export const DropdownMenu = ({ trigger, items, className }: DropdownMenuProps) => {

    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    return <div className={` relative  inline-block ${className} `}>
        <div ref={menuRef}>
            <DropdownMenuTrigger onClick={() => setOpen((prev) => !prev)} >
                {trigger}
            </DropdownMenuTrigger>
            <AnimatePresence>
                {open && (
                    <DropdownMenuContent triggerRef={menuRef} onClose={() => setOpen(false)}>
                        {items?.map((item, index) => <DropdownMenuItem onClick={item.onClick} key={index} >
                            {item.icon}
                            {item.label}
                        </DropdownMenuItem>)}
                    </DropdownMenuContent>
                )}
            </AnimatePresence>
        </div>
    </div>;
};

export const DropdownMenuTrigger = ({
    children,
    onClick
}: {
    children: ReactNode;
    onClick: () => void
}) => {
    return (
        <Button
            variant="outline"
            onClick={onClick}
            className=" inline-block  backdrop-blur-sm bg-primary-100/50    focus:outline-none"
        >
            {children}
        </Button>
    );
};

// Content with animation
export const DropdownMenuContent = ({
    children,
    onClose,
    triggerRef, // سنحتاج مرجع الزر لتحديد الموقع
}: {
    children: ReactNode;
    onClose?: () => void;
    triggerRef: React.RefObject<HTMLDivElement | null>;
}) => {
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    // حساب موقع الزر في الشاشة عند الفتح
    useEffect(() => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setCoords({
                top: rect.bottom + window.scrollY, // أسفل الزر
                left: rect.right - 150 + window.scrollX, // محاذاة لليمين (يمكنك تعديل الـ 150 حسب عرض المنيو)
            });
        }
    }, [triggerRef]);

    return createPortal(
        <motion.div
            initial={{ opacity: 0, scale: 0.9, y: -4 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: -4 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
            className="fixed bg-white border border-primary-200 rounded-md shadow-lg z-[9999] origin-top-right min-w-[150px]"
            style={{
                top: coords.top + 8,
                left: coords.left
            }}
            onClick={onClose}
        >
            {children}
        </motion.div>,
        document.body // يتم الرندرة في الـ body مباشرة
    );
};

export const DropdownMenuItem = ({
    children,
    onClick,
}: {
    children: ReactNode;
    onClick?: () => void;

}) => (
    <motion.button
        whileTap={{ scale: 0.97 }}
        onClick={onClick}
        className={`w-full hover:bg-primary-700 hover:text-white  duration-300 flex text-primary-900 justify-start gap-2 items-center  text-start px-3 py-2 text-sm cursor-pointer`}
    >
        <div className=" w-full h-full min-w-[100px] flex gap-2 items-center " >{children}</div>
    </motion.button>
);

// Separator
export const DropdownMenuSeparator = () => (
    <div className="h-px bg-primary-200 my-1" />
);
